"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function NewsletterStrip() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#064e3b] py-16 text-center text-white">
      <div className="mx-auto max-w-2xl px-6">
        <h3 className="mb-2 text-2xl font-bold">
          {t("blog.newsletter.title")}
        </h3>
        <p className="mb-8 text-sm text-white/70">
          {t("blog.newsletter.subtitle")}
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <input
            type="email"
            placeholder={String(t("blog.newsletter.placeholder"))}
            className="w-full max-w-sm rounded bg-white px-5 py-3 text-sm text-[#064e3b] placeholder-[#064e3b]/40 outline-none"
          />
          <button className="whitespace-nowrap rounded bg-[#fbbf24] px-6 py-3 text-sm font-bold text-[#064e3b] transition hover:bg-[#ea580c] hover:text-white">
            {t("blog.newsletter.button")}
          </button>
        </div>
        <p className="mt-4 text-xs text-white/40">
          {t("blog.newsletter.disclaimer")}
        </p>
      </div>
    </section>
  );
}